import  { KEYUTIL, utf8tohex, RSAKey } from "jsrsasign";
import forge from "node-forge";
import { PrivKey } from "./privkey";
import RSA from "./rsa";
import { PrivateKey as PKInterface } from "./interface";
import { AgentKey } from "./agent";
enum TYPES {
    RSA,
    ED25519
};

export  default class PrivateKey {
    constructor () {

    }
    static isEncrypted(str) {
        return str.substr('ENCRYPTED'); 
    }
    static decryptKey(str, passwd = '') {
        let rsa = forge.pki.decryptRsaPrivateKey(str, passwd);
        return new PrivKey(str, rsa);

    }
    static factory(str): PKInterface {
        try {
            return new PrivKey(str);
            let lines = str.split('\n');
            if(lines[0].search(/-----BEGIN RSA PRIVATE KEY-----/) >=0){
                return new RSA(str);
            }else if(lines[0].search(/-----BEGIN PRIVATE KEY-----/) >= 0){
                return new RSA(str);
            }else if(lines[0].search(/-----BEGIN ENCRYPTED PRIVATE KEY-----/) >= 0){
                return new RSA(str);
            //} else if(lines[0].search(/-----BEGIN OPENSSH PRIVATE KEY-----/) >= 0) {
            //  return new Ed25519(str);
            } else {
                throw new Error('Private key format not supported'); 
            }
        } catch(e) {
             console.log(e);
            throw e;
        }
    }
}
